import { Component, OnInit, OnDestroy } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import 'rxjs/add/operator/switchMap';
import {ModalService} from '../services/modalService/modal.service';
import {ModalHelper} from '../services/modalService/modal.helper';
import {Observable} from 'rxjs/Observable';
import {LocalStorageService} from 'angular-2-local-storage';

export interface LoseReportModalModel {
  title: string;
  data: any;
}

@Component({
  selector: 'app-lose-report-modal',
  templateUrl: './lose-report-modal.component.html',
  styleUrls: ['./lose-report-modal.component.css']
})
export class LoseReportModalComponent extends DialogComponent<LoseReportModalModel, boolean> implements OnInit, OnDestroy {
  title: string;
  data: any;
  isSuccess: boolean;
  currentLang: string;
  
  constructor(dialogService: DialogService,
  			  private modalService: ModalService,
  			  private modalHelper: ModalHelper,
  			  private localStorageService: LocalStorageService) {
    super(dialogService);
  }
 
  ngOnInit() {
    this.isSuccess = true;
    this.localStorageService.set('isAccessLogInMenuClose', false);
  	this.currentLang = localStorage.getItem('lang') || 'en';
  	document.getElementsByTagName('body')[0].classList.add('modal-open');
  }
  
  closeLoseReportModal() {
	  this.result = true;
	  this.localStorageService.set('isAccessLogInMenuClose', true);
	  this.close();
  }
  
  closeLoseReportModalNoAction() {
	  this.result = false;
	  this.close();
  }
  
  openSignUpModal() {
	  this.result = true;
	  let data : any = {};
  	  this.localStorageService.set('isAccessLogInMenu', true);
	  data.winReload = true;
	  this.modalHelper.openCreate(data, null);
  }
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/custom-modals/lose-report-modal.component.ts